import { Toast } from 'primereact/toast';
import Avatar from '@mui/material/Avatar';
import { Button } from 'primereact/button';
import { useLocation } from 'react-router-dom';
import React, { useRef, useEffect } from 'react';

let toastBC = null;

const ToastManager = () => {

    toastBC = useRef(null);
    const location = useLocation();


    const clear = () => {
        toastBC.current.clear()

    };

    useEffect(() => { clear() }, [location]);
    // useEffect(() => {
    //     if (document.querySelector('.transparent-toast')?.style?.display) {
    //         document.querySelector('.transparent-toast').style.display = 'none';
    //     }
    // }, []);


    return (<Toast ref={toastBC} position="bottom-left" onRemove={clear} className="transparent-toast" />);
};

const notifyWithToast = async (title, summary, funk, messageOnClick, life = 3000, icon = 'avriNotify.png') => {

    try {
        if (toastBC && toastBC.current) {
            await new Promise(resolve => setTimeout(resolve, 200));
            await toastBC.current.clear();
        }

        const toastElement = document.querySelector('.transparent-toast');
        if (toastElement) {
            toastElement.style.display = 'block';
        }

        const iconToDisplay = <img src={require('../data/imgs/icons/app/' + icon)} alt="localIcon" style={{ width: '48px', height: '48px', borderRadius: '8px' }} />
        
        toastBC.current.show({
            closable: false,
            severity: 'info',
            summary: summary,
            life: life,
            className: 'transparent-toast',
            content: (props) => (
                <ToastContent
                    title={title}
                    funk={funk}
                    messageOnClick={messageOnClick}
                    life={life}
                    iconToDisplay={iconToDisplay}
                    props={props}
                />
            ),
            // onShow: () => {
            //     document.querySelector('.transparent-toast').style.display = 'block';
            //     document.querySelector('.transparent-toast').style.border = '1px solid rgba(114, 129, 145, 0.29)';
            //     document.querySelector('.transparent-toast').style.maxHeight = '27.5%';
            //     document.querySelector('.transparent-toast').style.width = '100%';
            // },
            onHide: () => {
                const toast = document.querySelector('.transparent-toast');
                if (toast) toast.style.display = 'none';
            }
        });

        await new Promise(resolve => setTimeout(resolve, life));
        const toast = document.querySelector('.transparent-toast');
        if (toast) toast.style.display = 'none';
    } catch (error) {
        console.error('Error in notifyWithToast:', error);
    }
};

const ToastContent = ({ title, funk, messageOnClick, life, iconToDisplay, props }) => {

    return (
        <>
            <div className="flex flex-column align-items-left" style={{ flex: '1' }}>

                <div className="flex align-items-center gap-2">
                    <Avatar 
                        shape="circle"
                        style={{
                            background: 'linear-gradient(135deg, #4285f4 0%, #34a853 100%)',
                            boxShadow: '0 4px 12px rgba(66, 133, 244, 0.3)',
                            padding: '4px'
                        }}
                    >{iconToDisplay}</Avatar>
                    <div style={{ marginLeft: "8px" }}></div>
                    <span className="font-bold text-lg my-1 text-3000">{title || 'System'}</span>
                </div>

                {funk?.name &&
                    <>
                        <div style={{ marginBottom: '10px' }}></div>
                        <div className="text-lg my-1 text-3000" style={{ fontWeight: '700' }}>{props.message.summary}</div>
                        <br />
                        <div className="card flex flex-wrap justify-content-left gap-8">
                            <Button
                                label={funk.name || 'Reply'}
                                severity="info"
                                rounded onClick={async () => {
                                    try {
                                        funk.impl();
                                        if (messageOnClick) {
                                            await toastBC.current.clear();
                                            const toast = document.querySelector('.transparent-toast');
                                            if (toast) toast.style.display = 'block';
                                            
                                            await new Promise(resolve => setTimeout(resolve, 100));
                                            toastBC.current.show({
                                                severity: 'success',
                                                summary: messageOnClick || 'Success !',
                                                life: life || 3000,
                                            });
                                            await new Promise(resolve => setTimeout(resolve, life));
                                            await toastBC.current.clear();
                                            if (toast) toast.style.display = 'none';
                                        }
                                    } catch (error) {
                                        console.error('Error in toast button click:', error);
                                    }
                                }} />
                        </div>
                    </>}
            </div>
        </>
    );
};

export { notifyWithToast, ToastManager };
